(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire06c0"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire06c0"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("k6m3W", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $ea257b6026b95758$export$6503ec6e8aabbaf; }, function (v) { return $ea257b6026b95758$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $ea257b6026b95758$export$f7ad0328861e2f03; }, function (v) { return $ea257b6026b95758$export$f7ad0328861e2f03 = v; });
var $ea257b6026b95758$export$6503ec6e8aabbaf;
var $ea257b6026b95758$export$f7ad0328861e2f03;
"use strict";
var $ea257b6026b95758$var$mapping = new Map();
function $ea257b6026b95758$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$ea257b6026b95758$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $ea257b6026b95758$var$resolve(id) {
    var resolved = $ea257b6026b95758$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$ea257b6026b95758$export$6503ec6e8aabbaf = $ea257b6026b95758$var$register;
$ea257b6026b95758$export$f7ad0328861e2f03 = $ea257b6026b95758$var$resolve;

});

parcelRegister("fT1lQ", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $b90d0a6da4c45ea0$export$bdfd709ae4826697; }, function (v) { return $b90d0a6da4c45ea0$export$bdfd709ae4826697 = v; });
var $b90d0a6da4c45ea0$export$bdfd709ae4826697;
var $b90d0a6da4c45ea0$export$c9e73fbda7da57b6;
var $b90d0a6da4c45ea0$export$5a759dc7a1cfb72a;
"use strict";
var $b90d0a6da4c45ea0$var$bundleURL = {};
function $b90d0a6da4c45ea0$var$getBundleURLCached(id) {
    var value = $b90d0a6da4c45ea0$var$bundleURL[id];
    if (!value) {
        value = $b90d0a6da4c45ea0$var$getBundleURL();
        $b90d0a6da4c45ea0$var$bundleURL[id] = value;
    }
    return value;
}
function $b90d0a6da4c45ea0$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $b90d0a6da4c45ea0$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $b90d0a6da4c45ea0$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $b90d0a6da4c45ea0$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$b90d0a6da4c45ea0$export$bdfd709ae4826697 = $b90d0a6da4c45ea0$var$getBundleURLCached;
$b90d0a6da4c45ea0$export$c9e73fbda7da57b6 = $b90d0a6da4c45ea0$var$getBaseURL;
$b90d0a6da4c45ea0$export$5a759dc7a1cfb72a = $b90d0a6da4c45ea0$var$getOrigin;

});

var $cb02d8fc104dd729$exports = {};


(parcelRequire("k6m3W")).register((parcelRequire("fT1lQ")).getBundleURL("7mhIy"), JSON.parse('["7mhIy","index.88dd943b.js","ccLnZ","Grocery.3d16eb23.js"]'));

})();
//# sourceMappingURL=index.runtime.d34a7365.js.map
